import { useContext, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';

import BeginStep from './steps/BeginStep';
import LocationStep from './steps/LocationStep';
import getOffset from './helpers/getOffset';
import ConsoStep from './steps/ConsoStep';
import InfosStep from './steps/InfosStep';
import RecapStep from './steps/RecapStep';
import ResultStep from './steps/ResultStep';

import SimulationContext from "./contexts/Simulation";
import useFetch from './hooks/useFetch';

import ImgLoader from "./img/animation_wait.gif";


const steps = [
  { key: 'begin', label: 'Accueil', 'component': BeginStep },
  { key: 'localisation', label: 'Localisation', 'component': LocationStep },
  { key: 'consommation', label: 'Consommation', 'component': ConsoStep },
  { key: 'informations', label: 'Informations', 'component': InfosStep },
  { key: 'recapitulatif', label: 'Récapitulatif', 'component': RecapStep },
  { key: 'resultats', label: 'Résultats', 'component': ResultStep }
];

const Stepper = ({ initialProps }) => {
  const [simParams, setSimParams] = useContext(SimulationContext);
  const [doFetchSimResults, responseSimResults] = useFetch(
    `${process.env.REACT_APP_SIM_API_URL}/finsim`
  );

  const offset = getOffset(document.getElementById('simroot'));
  const height = window.innerHeight - offset.y;

  const handleSlideChange = (s) => {
    setSimParams({
      ...simParams,
      currentStep: s.activeIndex,
      allowSlideNext: (simParams.validSteps >> s.activeIndex) & 1
    });

    if (steps[s.activeIndex].key === 'recapitulatif') {
      const simRequestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Auth-Token': process.env.REACT_APP_SIM_API_KEY
        },
        body: JSON.stringify({
          'latitude': simParams.location.latitude,
          'longitude': simParams.location.longitude,
          'consumption_amount': simParams.consos[2],
          'consumption_type': 'kw_monthly',
          'infos_presence': simParams.infos.daily_presence
        }),
      };
      doFetchSimResults(simRequestOptions);
    }
  }

  useEffect(() => {
    if (responseSimResults)
      setSimParams({
        ...simParams,
        simResults: responseSimResults
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [responseSimResults]);

  useEffect(() => {
    if (process.env?.NODE_ENV === 'development')
      console.log(simParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [simParams.currentStep]);

  useEffect(() => {
    if (initialProps?.zip)
    {
      setSimParams({
        ...simParams, 
        currentStep: 2,
        location: {
          zip_code: initialProps.zip,
          name: initialProps.city,
          latitude: initialProps.lat,
          longitude: initialProps.lon
        },
        allowSlideNext: false, 
        validSteps: 19
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialProps]);

  return (
    <div className="simcontainer">
      <Swiper
        id="stepper"
        className={`step${simParams.currentStep}`}
        navigation={true}
        direction='vertical'
        slidesPerView={1}
        modules={[Navigation]}
        height={height}
        style={{ height: height }}
        allowSlideNext={simParams.allowSlideNext}
        onSlideChange={handleSlideChange}
        initialSlide={initialProps?.zip ? 2 : 0}
      >
        {steps.map((step, index) =>
          <SwiperSlide className='content'>
            <step.component
              key={step.key}
              step={index}
              initialProps={initialProps}
            />
          </SwiperSlide>
        )}
      </Swiper>
      <div id="loader">
        <img src={ImgLoader} alt=""/>
      </div>
    </div>
  )
}

export default Stepper;